(function () {
  'use strict';

  /* ==========================================================
     HELPERS
  ========================================================== */

  function getCommunitySections(scope) {
    var root =
      scope instanceof Element ||
      scope instanceof Document
        ? scope
        : document;

    var sections = [];

    if (
      root instanceof Element &&
      root.matches('[data-hb-community-section]')
    ) {
      sections.push(root);
    }

    if (root.querySelectorAll) {
      root
        .querySelectorAll('[data-hb-community-section]')
        .forEach(function (section) {
          if (sections.indexOf(section) === -1) {
            sections.push(section);
          }
        });
    }

    return sections;
  }


  /* ==========================================================
     VIDEOS
  ========================================================== */

  function initializeHBCommunityVideos(scope) {
    var root =
      scope instanceof Element ||
      scope instanceof Document
        ? scope
        : document;

    var videoCards =
      root.querySelectorAll(
        '[data-hb-community-video]'
      );

    videoCards.forEach(function (card) {
      if (
        card.dataset.hbCommunityInitialized ===
        'true'
      ) {
        return;
      }

      var video =
        card.querySelector('video');

      var trigger =
        card.querySelector(
          '[data-hb-community-video-trigger]'
        );

      if (!video || !trigger) {
        return;
      }

      card.dataset.hbCommunityInitialized =
        'true';


      /* POSTER CLICK */

      trigger.addEventListener(
        'click',
        function (event) {
          event.preventDefault();

          card.classList.add('is-playing');

          var promise = video.play();

          if (
            promise &&
            typeof promise.catch === 'function'
          ) {
            promise.catch(function () {
              card.classList.remove(
                'is-playing'
              );
            });
          }
        }
      );


      /* VIDEO START */

      video.addEventListener(
        'play',
        function () {
          card.classList.add('is-playing');
        }
      );


      /* VIDEO END */

      video.addEventListener(
        'ended',
        function () {
          card.classList.remove('is-playing');

          try {
            video.currentTime = 0;
          } catch (error) {
            /* Nothing required */
          }
        }
      );


      /* CLICK VIDEO TO PLAY / PAUSE
         ONLY WHEN NATIVE CONTROLS ARE OFF */

      video.addEventListener(
        'click',
        function () {
          if (video.controls) return;

          if (video.paused) {
            video.play();
          } else {
            video.pause();
          }
        }
      );
    });
  }


  /* ==========================================================
     TESTIMONIAL SHOW MORE / SHOW LESS
  ========================================================== */

  function initializeTestimonialToggle(scope) {
    var sections =
      getCommunitySections(scope);

    sections.forEach(function (section) {
      var button =
        section.querySelector(
          '[data-hb-testimonials-toggle]'
        );

      var grid =
        section.querySelector(
          '[data-hb-testimonials-grid]'
        );

      if (!button || !grid) {
        return;
      }

      if (
        button.dataset.hbToggleInitialized ===
        'true'
      ) {
        return;
      }

      button.dataset.hbToggleInitialized =
        'true';

      var label =
        button.querySelector(
          '[data-hb-testimonials-toggle-label]'
        );

      var showMoreText =
        button.getAttribute(
          'data-show-more-text'
        ) || 'Show more';

      var showLessText =
        button.getAttribute(
          'data-show-less-text'
        ) || 'Show less';


      button.addEventListener(
        'click',
        function () {
          var isExpanded =
            grid.classList.toggle(
              'is-expanded'
            );

          button.setAttribute(
            'aria-expanded',
            isExpanded
              ? 'true'
              : 'false'
          );

          if (label) {
            label.textContent =
              isExpanded
                ? showLessText
                : showMoreText;
          }


          /* WHEN COLLAPSING, BRING GRID
             BACK INTO VIEW IF REQUIRED */

          if (!isExpanded) {
            var gridTop =
              grid.getBoundingClientRect().top +
              window.pageYOffset;

            var viewportTop =
              window.pageYOffset;

            if (viewportTop > gridTop) {
              grid.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
              });
            }
          }
        }
      );
    });
  }


  /* ==========================================================
     DESKTOP TESTIMONIAL CAROUSEL
  ========================================================== */

  function initializeTestimonialCarousel(scope) {
    var sections =
      getCommunitySections(scope);

    sections.forEach(function (section) {
      var track =
        section.querySelector(
          '[data-hb-testimonials-carousel]'
        );

      if (!track) {
        return;
      }

      if (
        track.dataset.hbCarouselInitialized ===
        'true'
      ) {
        return;
      }

      var cards =
        Array.prototype.slice.call(
          track.querySelectorAll(
            '.hb-testimonial'
          )
        );

      if (!cards.length) {
        return;
      }

      track.dataset.hbCarouselInitialized =
        'true';


      var prevButton =
        section.querySelector(
          '[data-hb-testimonial-prev]'
        );

      var nextButton =
        section.querySelector(
          '[data-hb-testimonial-next]'
        );


      var desktopMedia =
        window.matchMedia(
          '(min-width: 990px)'
        );

      var reducedMotion =
        window.matchMedia(
          '(prefers-reduced-motion: reduce)'
        );


      var columns =
        parseInt(
          track.dataset.desktopColumns || '3',
          10
        );

      var scrollBy =
        parseInt(
          track.dataset.scrollBy || '1',
          10
        );

      var loop =
        track.dataset.loop === 'true';

      var autoplay =
        track.dataset.autoplay === 'true';

      var autoplaySpeed =
        parseInt(
          track.dataset.autoplaySpeed || '5000',
          10
        );


      var autoplayTimer = null;
      var scrollFrame = null;
      var resizeTimer = null;


      /* ==============================================
         CARD POSITION
      ============================================== */

      function getCardPosition(card) {
        var trackRect =
          track.getBoundingClientRect();

        var cardRect =
          card.getBoundingClientRect();

        return (
          cardRect.left -
          trackRect.left +
          track.scrollLeft
        );
      }


      /* ==============================================
         MAX POSSIBLE STARTING CARD
      ============================================== */

      function getMaxIndex() {
        return Math.max(
          0,
          cards.length - columns
        );
      }


      /* ==============================================
         FIND CURRENT CARD
      ============================================== */

      function getCurrentIndex() {
        var scrollLeft =
          track.scrollLeft;

        var closestIndex = 0;
        var closestDistance = Infinity;

        cards.forEach(
          function (card, index) {
            var position =
              getCardPosition(card);

            var distance =
              Math.abs(
                position - scrollLeft
              );

            if (
              distance <
              closestDistance
            ) {
              closestDistance =
                distance;

              closestIndex =
                index;
            }
          }
        );

        return Math.min(
          closestIndex,
          getMaxIndex()
        );
      }


      /* ==============================================
         SCROLL TO CARD
      ============================================== */

      function scrollToIndex(
        index,
        smooth
      ) {
        if (!cards[index]) {
          return;
        }

        var position =
          getCardPosition(
            cards[index]
          );

        track.scrollTo({
          left: position,
          behavior:
            smooth === false ||
            reducedMotion.matches
              ? 'auto'
              : 'smooth'
        });
      }


      /* ==============================================
         MOVE CAROUSEL
      ============================================== */

      function moveCarousel(direction) {
        if (!desktopMedia.matches) {
          return;
        }

        var currentIndex =
          getCurrentIndex();

        var maxIndex =
          getMaxIndex();

        var targetIndex =
          currentIndex +
          scrollBy * direction;


        /* LOOP */

        if (loop) {
          if (
            targetIndex >
            maxIndex
          ) {
            targetIndex = 0;
          }

          if (targetIndex < 0) {
            targetIndex =
              maxIndex;
          }
        }


        /* NO LOOP */

        else {
          targetIndex =
            Math.max(
              0,
              Math.min(
                targetIndex,
                maxIndex
              )
            );
        }


        scrollToIndex(
          targetIndex,
          true
        );
      }


      /* ==============================================
         ARROW STATE
      ============================================== */

      function updateButtons() {
        if (
          !prevButton &&
          !nextButton
        ) {
          return;
        }

        var maxScroll =
          Math.max(
            0,
            track.scrollWidth -
            track.clientWidth
          );

        var currentScroll =
          track.scrollLeft;

        var hasOverflow =
          maxScroll > 2;


        if (!hasOverflow) {
          if (prevButton) {
            prevButton.disabled = true;
          }

          if (nextButton) {
            nextButton.disabled = true;
          }

          return;
        }


        if (loop) {
          if (prevButton) {
            prevButton.disabled = false;
          }

          if (nextButton) {
            nextButton.disabled = false;
          }

          return;
        }


        if (prevButton) {
          prevButton.disabled =
            currentScroll <= 2;
        }


        if (nextButton) {
          nextButton.disabled =
            currentScroll >=
            maxScroll - 2;
        }
      }


      /* ==============================================
         AUTOPLAY
      ============================================== */

      function stopAutoplay() {
        if (!autoplayTimer) {
          return;
        }

        clearInterval(
          autoplayTimer
        );

        autoplayTimer =
          null;
      }


      function startAutoplay() {
        stopAutoplay();

        if (!autoplay) {
          return;
        }

        if (!desktopMedia.matches) {
          return;
        }

        if (reducedMotion.matches) {
          return;
        }

        if (
          cards.length <=
          columns
        ) {
          return;
        }


        autoplayTimer =
          setInterval(
            function () {
              /*
               * When looping is disabled
               * restart from beginning once
               * the carousel reaches the end.
               */

              if (!loop) {
                var maxScroll =
                  Math.max(
                    0,
                    track.scrollWidth -
                    track.clientWidth
                  );

                if (
                  track.scrollLeft >=
                  maxScroll - 2
                ) {
                  scrollToIndex(
                    0,
                    true
                  );

                  return;
                }
              }

              moveCarousel(1);
            },
            autoplaySpeed
          );
      }


      /* ==============================================
         PREVIOUS BUTTON
      ============================================== */

      if (prevButton) {
        prevButton.addEventListener(
          'click',
          function () {
            moveCarousel(-1);

            if (autoplay) {
              startAutoplay();
            }
          }
        );
      }


      /* ==============================================
         NEXT BUTTON
      ============================================== */

      if (nextButton) {
        nextButton.addEventListener(
          'click',
          function () {
            moveCarousel(1);

            if (autoplay) {
              startAutoplay();
            }
          }
        );
      }


      /* ==============================================
         TRACK SCROLL
      ============================================== */

      track.addEventListener(
        'scroll',
        function () {
          if (scrollFrame) {
            cancelAnimationFrame(
              scrollFrame
            );
          }

          scrollFrame =
            requestAnimationFrame(
              function () {
                updateButtons();
              }
            );
        },
        {
          passive: true
        }
      );


      /* ==============================================
         PAUSE AUTOPLAY ON HOVER
      ============================================== */

      track.addEventListener(
        'mouseenter',
        stopAutoplay
      );

      track.addEventListener(
        'mouseleave',
        startAutoplay
      );


      /* ==============================================
         PAUSE AUTOPLAY DURING
         KEYBOARD INTERACTION
      ============================================== */

      section.addEventListener(
        'focusin',
        stopAutoplay
      );

      section.addEventListener(
        'focusout',
        function () {
          setTimeout(
            function () {
              if (
                !section.contains(
                  document.activeElement
                )
              ) {
                startAutoplay();
              }
            },
            0
          );
        }
      );


      /* ==============================================
         TOUCH / POINTER INTERACTION
      ============================================== */

      track.addEventListener(
        'pointerdown',
        stopAutoplay
      );

      track.addEventListener(
        'pointerup',
        function () {
          startAutoplay();
        }
      );


      /* ==============================================
         TAB VISIBILITY
      ============================================== */

      document.addEventListener(
        'visibilitychange',
        function () {
          if (document.hidden) {
            stopAutoplay();
          } else {
            startAutoplay();
          }
        }
      );


      /* ==============================================
         DESKTOP / MOBILE CHANGE
      ============================================== */

      function handleBreakpointChange() {
        if (
          !desktopMedia.matches
        ) {
          stopAutoplay();

          return;
        }

        updateButtons();
        startAutoplay();
      }


      if (
        typeof desktopMedia
          .addEventListener ===
        'function'
      ) {
        desktopMedia.addEventListener(
          'change',
          handleBreakpointChange
        );
      } else if (
        typeof desktopMedia
          .addListener ===
        'function'
      ) {
        desktopMedia.addListener(
          handleBreakpointChange
        );
      }


      /* ==============================================
         WINDOW RESIZE
      ============================================== */

      window.addEventListener(
        'resize',
        function () {
          clearTimeout(
            resizeTimer
          );

          resizeTimer =
            setTimeout(
              function () {
                updateButtons();
              },
              100
            );
        }
      );


      /* ==============================================
         INITIAL STATE
      ============================================== */

      updateButtons();
      startAutoplay();
    });
  }


  /* ==========================================================
     INITIALIZE EVERYTHING
  ========================================================== */

  function initializeHBCommunity(scope) {
    initializeHBCommunityVideos(
      scope
    );

    initializeTestimonialToggle(
      scope
    );

    initializeTestimonialCarousel(
      scope
    );
  }


  /* ==========================================================
     NORMAL PAGE LOAD
  ========================================================== */

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        initializeHBCommunity(
          document
        );
      }
    );
  } else {
    initializeHBCommunity(
      document
    );
  }


  /* ==========================================================
     SHOPIFY THEME EDITOR
  ========================================================== */

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      initializeHBCommunity(
        event.target
      );
    }
  );

})();